import Tooltip from '../../../../../common/StyledToolTip';
import { withStyles } from '@material-ui/core';
import { isLocationMappingEditable } from '../../utils';
import { compose } from 'recompose';
import { withUserProfile } from '../../../../../../userProfile/userProfileContext';

const styles = (theme) => ({
  container: {
    marginTop: 4
  },
  editIconStyle: { cursor: 'pointer', color: theme.iconColor, },
  deleteIconStyle: { marginLeft: 8, cursor: 'pointer', color: theme.iconColor, },
  disableIcon: {
    cursor: 'not-allowed',
    opacity: 0.7
  }
});

const CardAction = ({ onEdit, onDelete, classes, userData }) => {
  const isEditEnabled = isLocationMappingEditable(userData?.userProfile)
  return (
    <div className={classes.container}>
      <Tooltip title={isEditEnabled ? 'Edit' : 'Edit (Disabled)'}>
        <i
          className={`${classes.editIconStyle} icon-icon_edit ${
            isEditEnabled ? classes.iconStyle : classes.disableIcon
          }`}
          onClick={isEditEnabled ? onEdit : null}
        />
      </Tooltip>

      <Tooltip title={isEditEnabled ? 'Delete' : 'Delete (Disabled)'}>
        <i
          className={`${classes.deleteIconStyle} icon-icon_delete ${
            isEditEnabled ? classes.iconStyle : classes.disableIcon
          }`}
          onClick={isEditEnabled ? onDelete : null}
        />
      </Tooltip>
    </div>
  );
};

export default compose(withUserProfile, withStyles(styles))(CardAction);
